const KEY = "dh_account_settings";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function emptyAccountSettings() {
  return {
    portal: {
      advisorLabel: "Your Advisor",
      showTitle: true,
      showPhone: true,
      showEmail: true,
      showOffice: true,
      allowMessages: true,
      allowUploads: true,
      showProgress: true,
      showTips: true,
      defaultPortal: "both",
    },
    notifications: {
      email: true,
      sms: false,
      calendar: true,
      tasks: true,
      activity: true,
      frequency: "immediate",
    },
    privacy: {
      twoFactor: false,
      recoveryEmail: "",
    },
    billing: {
      plan: "Office desk (prototype)",
      renewal: "",
      method: "Not connected",
    },
    sessions: [],
    updated_at: null,
  };
}

export function getAccountSettings(userId) {
  if (!userId) return emptyAccountSettings();
  const stored = readAll()[userId] || {};
  const base = emptyAccountSettings();
  return {
    ...base,
    ...stored,
    portal: { ...base.portal, ...(stored.portal || {}) },
    notifications: { ...base.notifications, ...(stored.notifications || {}) },
    privacy: { ...base.privacy, ...(stored.privacy || {}) },
    billing: { ...base.billing, ...(stored.billing || {}) },
    sessions: Array.isArray(stored.sessions) ? stored.sessions : [],
  };
}

export function saveAccountSettings(userId, settings) {
  if (!userId) return settings;
  const all = readAll();
  const next = { ...emptyAccountSettings(), ...settings, updated_at: new Date().toISOString() };
  all[userId] = next;
  writeAll(all);
  return next;
}

export function recordAccountSession(userId) {
  if (!userId || typeof navigator === "undefined") return;
  const settings = getAccountSettings(userId);
  const row = {
    at: new Date().toISOString(),
    device: navigator.userAgent.slice(0, 80),
    label: "This browser",
  };
  const sessions = [row, ...(settings.sessions || [])].slice(0, 8);
  saveAccountSettings(userId, { ...settings, sessions });
}
